export default __webpack_public_path__ + "static/media/TodoAPp.52c71d36.png";